import { useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import './fileContentsPanelStyle.css';
import _ from 'lodash';
import ClientUserService from '../../../../services/client-services/clientUserService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileWord, faDownload } from '@fortawesome/free-solid-svg-icons';
const FileContentsPanel = ({ title, fileList }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const itemsToShow = isExpanded ? fileList.length : 2;

  const toggleExpand = () => setIsExpanded(!isExpanded);

  const downloadFile = (resumePath, fileName) => {
    ClientUserService.downloadFile(encodeURI(resumePath))
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error(err));
  };

  const truncateFileName = (name) => {
    return name.length > 10 ? `${name.slice(0, 10)}...` : name;
  };

  const getFileIcon = (filename) => {
    const ext = filename?.split('.').pop()?.toLowerCase();
    if (ext === 'pdf') return faFilePdf;
    if (ext === 'doc' || ext === 'docx') return faFileWord;
    return faFilePdf;
  };

  const renderNoFilesMessage = () => (
    <Row>
      <Col>
        {/* <p className="no-files-message">No data available</p> */}
      </Col>
    </Row>
  );

  return (
    <Card className="fileContentsPanel mt-2">
      <Card.Body>
        <Container>
          <Row>
            <Col>
              <h3>{title}</h3>
            </Col>
            <Col className="text-right">
              {title !== 'Additional Information' && fileList && fileList.length > 2 && (
                <button className="toggle-btn" onClick={toggleExpand}>
                  {isExpanded ? 'View Less' : 'View More'}
                </button>
              )}
            </Col>
          </Row>
          {fileList?.length === 0 || !fileList
            ? renderNoFilesMessage()
            : _.map(fileList.slice(0, title !== 'Additional Information' ? itemsToShow : fileList.length), (file) => {
              const originalName = _.get(file, 'originalName', '');
              const truncatedName = truncateFileName(originalName);

              return (
                <Row className={`mt-2 p-2 ${title === 'Additional Information' ? 'single-row-text' : ''}`} key={originalName}>
                  <Col lg={12}>
                    <div className="file-row d-flex align-items-center justify-content-between flex-wrap">
                      <div className="file-icon">
                        <FontAwesomeIcon icon={getFileIcon(originalName)} style={{ color: '#F35824' }} />
                      </div>
                      <div className="file-info flex-grow-1">
                        <div title={originalName} className="truncated-file-name">
                          {truncatedName}
                        </div>
                      </div>
                      <div className="download-icon">
                        <a
                          href="#"
                          // onClick={(event) => {
                          //   event.preventDefault();
                          //   downloadFile(_.get(file, 'path'), originalName);
                          // }}
                          onClick={(event) => {
                            event.preventDefault();

                            const filePath = _.get(file, 'path');
                            const originalName = _.get(file, 'originalName', '');

                            const ext = originalName.split('.').pop().toLowerCase();
                            const knownExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png'];

                            const fileName = knownExtensions.includes(ext) ? originalName : `${originalName}.pdf`;

                            downloadFile(filePath, fileName);
                          }}

                        >
                          <FontAwesomeIcon icon={faDownload} size="sm" style={{ color: '#F35824', cursor: 'pointer' }} />
                        </a>
                      </div>
                    </div>
                  </Col>
                </Row>
              );
            })}
        </Container>
      </Card.Body>
    </Card>
  );
};

export default FileContentsPanel;